import {
  ApplianceIcon,
  FurnitureIcon,
  GarageIcon,
  HouseIcon,
  PileOfRubbishIcon,
} from './CategoryIcons';
import './PopularRubbish.css';

const ITEMS = [
  { label: 'Pile of Scrap', href: '#pile-of-scrap', Icon: PileOfRubbishIcon },
  { label: 'Copper & Cable', href: '#copper-cable', Icon: FurnitureIcon },
  { label: 'White Goods', href: '#white-goods', Icon: ApplianceIcon },
  { label: 'Vehicle Parts', href: '#vehicle-parts', Icon: GarageIcon },
  { label: 'Site Scrap Clearance', href: '#site-scrap', Icon: HouseIcon },
];

export default function PopularRubbish() {
  return (
    <section className="popular-rubbish" aria-labelledby="popular-rubbish-heading">
      <div className="popular-rubbish-inner">
        <header className="popular-rubbish-header">
          <h2 id="popular-rubbish-heading">Popular Scrap Removal Services</h2>
          <p>Professional &amp; fast scrap metal collection in Leeds</p>
        </header>

        <ul className="popular-rubbish-grid">
          {ITEMS.map(({ label, href, Icon }) => (
            <li key={label}>
              <a className="popular-rubbish-item" href={href}>
                <span className="popular-rubbish-art">
                  <Icon />
                </span>
                <span className="popular-rubbish-label">
                  {label} <span aria-hidden="true">→</span>
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
